import { isEmpty } from '@intelligence/v3/utils/common';
import { buildDownloadDataNew as buildDownloadData, getCountryByCode } from '@intelligence/utils/commonUtils';
import { getStdAUMetricName } from '@intelligence/v3/utils/metric';
import { mergeGameDetailsData } from '../../utils';
import {
  buildPublisherConfigs,
  buildGenreConfigs,
  buildRegionCountryConfigs,
  buildReleaseDateConfigs,
  buildDateConfigs,
} from './common';
import { LANGUAGE_EN } from '@home/_config/config';
import {
  DATASOURCE_METRIC_KEY_MAP,
  DATASOURCE_METRIC_RATIO_KEY_MAP,
  getDBIMetricByDataSourceMetricKey,
} from '@intelligence/v3/_config/metrics';
import { DOWNLOAD_CFG_KEY } from '@intelligence/v3/constants';
import { DataCalculation } from '@intelligence/v3/enums/download';
import METRICS_LOCALE from '@intelligence/_locales/en-US/metric';

const getMetricNames = (params?: IRecord | null): string => {
  const granularity = params?.granularity || 'monthly';
  // const metrics = params?.metrics;
  const metrics = params?.metrics?.slice(1);

  if (!Array.isArray(metrics) || metrics.length === 0) {
    return '';
  }

  return metrics
    .map((metric) => {
      if (metric === DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS) {
        return getStdAUMetricName(LANGUAGE_EN, granularity);
      }

      const metricData = getDBIMetricByDataSourceMetricKey('mobile', metric);
      return metricData?.metricName?.en || '';
    })
    .join(', ');
};

const getMarketNames = (markets?: string[] | null, regionOptions?: any[] | null): string => {
  if (isEmpty(markets)) return '';
  if (isEmpty(regionOptions)) return markets!.join(', ');

  const marketNames = markets!.map((market) => {
    return getCountryByCode(market, regionOptions!)?.country_name_en || '';
  });

  return marketNames.join(', ');
};

export const getMobileOverlapDetailsConfig = (data: any, params: any, allParams: any) => {
  const isShowRatio = allParams?.ratio_show === 1;
  const regionOptions = allParams?.regionOptions || [];

  // 需要下载的指标映射
  const metricMap: IRecord<boolean> = params?.metrics?.reduce((acc: IRecord<boolean>, cur: string) => {
    return { ...acc, [cur]: true };
  }, {});

  // const hasMAUMetric = metricMap?.[DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS];
  const hasCrossAppUsageMetric = metricMap?.[DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE];
  const hasCrossAffinityMetric = metricMap?.[DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY];

  const publisherConfigs = buildPublisherConfigs({ ...allParams, company_show: 1 }, regionOptions);
  const genreConfigs = buildGenreConfigs({ ...allParams, genre_show: 1 });
  const regionCountryConfigs = buildRegionCountryConfigs(
    {
      ...allParams,
      [DOWNLOAD_CFG_KEY.REGION_METHOD]: DataCalculation.SeparateByCountry,
    },
    regionOptions,
  );
  const releaseDateConfigs = buildReleaseDateConfigs({ ...allParams, release_date_show: 1 });
  const dateConfigs = buildDateConfigs(allParams);

  const commonSheetConfig = [
    {
      title: 'Unified Game name',
      key: 'game_name',
    },
    ...publisherConfigs,
    ...genreConfigs,
    ...regionCountryConfigs,
    ...releaseDateConfigs,
    ...dateConfigs,
    // {
    //   title: getStdAUMetricName(LANGUAGE_EN, params?.granularity || 'monthly'),
    //   key: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS,
    //   when: hasMAUMetric,
    // },
    // {
    //   title: '%',
    //   key: DATASOURCE_METRIC_RATIO_KEY_MAP.SENSORTOWER__ACTIVE_USERS,
    //   when: () => isShowRatio && hasMAUMetric,
    // },
    {
      title: METRICS_LOCALE.dbi_metric_mobile_cross_usage,
      key: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
      when: hasCrossAppUsageMetric,
    },
    {
      title: '%',
      key: DATASOURCE_METRIC_RATIO_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
      when: () => isShowRatio && hasCrossAppUsageMetric,
    },
    {
      title: `${METRICS_LOCALE.dbi_metric_mobile_cross_affinity}(x)`,
      key: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
      when: () => hasCrossAffinityMetric,
    },
  ];

  return {
    stat: {
      sheetName: 'Cross Mobile Usage',
      style: 'normal',
      data: buildDownloadData(commonSheetConfig, mergeGameDetailsData(data?.[0]?.list, data?.[0]?.$ext?.entity_info)),
    },
    summary: {
      sheetName: `Summary`,
      style: 'summary',
      data: [
        ['Countries', getMarketNames(params?.markets, regionOptions)],
        ['Date Start', params?.start_date || ''],
        ['Date End', params?.end_date || ''],
        ['Metrics', getMetricNames(params)],
        ['Time Settings', 'Separate'],
        ['Region Settings', 'Market'],
        ['File Format', 'Excel'],
      ],
    },
  };
};
